// extracted by mini-css-extract-plugin
module.exports = {"container":"StepModale_container__K7oIK","col-2":"StepModale_col-2__1zft4"};